import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import 'react';
import 'tiny-warning';
import { deprecatedProp } from '../core/deprecated-prop.js';
const propTypes = {
  cardDividers: deprecatedProp(PropTypes.bool, 'Use dividers prop instead'),
  dividers: PropTypes.bool,
  gutter: PropTypes.oneOf(['standard', 'tight'])
};
const GridContainer = createComponent({
  displayName: 'GridContainer',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(props) {
      const classNameSet = new Set(['swan-grid-container']);
      if (props.dividers || props.cardDividers) classNameSet.add('swan-grid-dividers');
      if (props.gutter === 'tight') classNameSet.add('swan-grid-container-tight');
      return classNameSet;
    }
  }
});
GridContainer.defaultProps = {
  dividers: false,
  gutter: 'standard'
};
export { GridContainer };